import React, { useEffect, useState } from "react";

const AddToHomeScreen = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstalled, setIsInstalled] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [isDesktop, setIsDesktop] = useState(false);

    // ✅ Detect iOS (iPhone, iPad, iPod)
    const isIOS = () => {
        return /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
    };

    // ✅ Detect macOS (Desktop Safari)
    const isMacOS = () => {
        return (
            /macintosh|mac os x/.test(window.navigator.userAgent.toLowerCase()) &&
            !isIOS() // Ensure it's not an iPad running macOS-like UI
        );
    };

    // ✅ Detect Android
    const isAndroid = () => {
        return /android/.test(window.navigator.userAgent.toLowerCase());
    };

    // ✅ Detect Chrome on iOS (it behaves like Safari)
    const isIOSChrome = () => {
        return isIOS() && /crios/.test(window.navigator.userAgent.toLowerCase());
    };

    // ✅ Detect Desktop browsers (excluding mobile/tablet OS)
    const isDesktopBrowser = () => {
        return (
            !isIOS() &&
            !isAndroid() &&
            !isMacOS() &&
            /mozilla|chrome|safari|edge|opera/i.test(window.navigator.userAgent)
        );
    };

    useEffect(() => {
        setIsDesktop(isDesktopBrowser());

        if (!isIOS() && !isIOSChrome()) {
            window.addEventListener("beforeinstallprompt", (e) => {
                e.preventDefault();
                setDeferredPrompt(e);
            });

            window.addEventListener("appinstalled", () => {
                setIsInstalled(true);
            });

            return () => {
                window.removeEventListener("beforeinstallprompt", () => { });
                window.removeEventListener("appinstalled", () => { });
            };
        }
    }, []);

    const handleInstallClick = () => {
        const currentPage = window.location.pathname;
        localStorage.setItem("lastVisitedPage", currentPage);
        localStorage.setItem("webcard_code", currentPage.split('/').pop())
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    localStorage.setItem("lastVisitedPage", currentPage);
                }
                setDeferredPrompt(null);
            });
        }
    };

    return (
        <>
            {/* ✅ Show Install Button for Android & Windows (Desktop excluded) */}
            {!isInstalled && deferredPrompt && !isIOS() && !isIOSChrome() && !isDesktop && (
                <div className="add-btn" onClick={handleInstallClick} style={{ cursor: "pointer" }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="4" fill="#E55426" />
                        <g clipPath="url(#clip0_795_807)">
                            <path d="M12 20C11.7928 20 11.5941 19.9177 11.4476 19.7712C11.3011 19.6247 11.2188 19.426 11.2188 19.2188V4.78125C11.2188 4.57405 11.3011 4.37534 11.4476 4.22882C11.5941 4.08231 11.7928 4 12 4C12.2072 4 12.4059 4.08231 12.5524 4.22882C12.6989 4.37534 12.7812 4.57405 12.7812 4.78125V19.2188C12.7812 19.426 12.6989 19.6247 12.5524 19.7712C12.4059 19.9177 12.2072 20 12 20Z" fill="white" />
                            <path d="M19.2188 12.7812H4.78125C4.57405 12.7812 4.37534 12.6989 4.22882 12.5524C4.08231 12.4059 4 12.2072 4 12C4 11.7928 4.08231 11.5941 4.22882 11.4476C4.37534 11.3011 4.57405 11.2188 4.78125 11.2188H19.2188C19.426 11.2188 19.6247 11.3011 19.7712 11.4476C19.9177 11.5941 20 11.7928 20 12C20 12.2072 19.9177 12.4059 19.7712 12.5524C19.6247 12.6989 19.426 12.7812 19.2188 12.7812Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_795_807">
                                <rect width="16" height="16" fill="white" transform="translate(4 4)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            )}

            {/* ✅ Show Install Button for iOS and Chrome on iOS */}
            {isIOS() || isIOSChrome() ? (
                <div className="add-btn" onClick={() => setShowPopup(true)} style={{ cursor: "pointer" }}>
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="24" rx="4" fill="#E55426" />
                        <g clipPath="url(#clip0_795_807)">
                            <path d="M12 20C11.7928 20 11.5941 19.9177 11.4476 19.7712C11.3011 19.6247 11.2188 19.426 11.2188 19.2188V4.78125C11.2188 4.57405 11.3011 4.37534 11.4476 4.22882C11.5941 4.08231 11.7928 4 12 4C12.2072 4 12.4059 4.08231 12.5524 4.22882C12.6989 4.37534 12.7812 4.57405 12.7812 4.78125V19.2188C12.7812 19.426 12.6989 19.6247 12.5524 19.7712C12.4059 19.9177 12.2072 20 12 20Z" fill="white" />
                            <path d="M19.2188 12.7812H4.78125C4.57405 12.7812 4.37534 12.6989 4.22882 12.5524C4.08231 12.4059 4 12.2072 4 12C4 11.7928 4.08231 11.5941 4.22882 11.4476C4.37534 11.3011 4.57405 11.2188 4.78125 11.2188H19.2188C19.426 11.2188 19.6247 11.3011 19.7712 11.4476C19.9177 11.5941 20 11.7928 20 12C20 12.2072 19.9177 12.4059 19.7712 12.5524C19.6247 12.6989 19.426 12.7812 19.2188 12.7812Z" fill="white" />
                        </g>
                        <defs>
                            <clipPath id="clip0_795_807">
                                <rect width="16" height="16" fill="white" transform="translate(4 4)" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            ) : null}

            {/* ✅ Popup for iOS/macOS Instructions */}
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup">
                        <h2>Add to Home Screen</h2>
                        {isIOS() || isIOSChrome() ? (
                            <p>📲 On iOS, open <strong>Safari</strong>, tap the <strong>Share</strong> button, and select <strong>Add to Home Screen</strong>.</p>
                        ) : isMacOS() ? (
                            <p>🖥️ On macOS, open <strong>Safari</strong>, click the <strong>Share</strong> button, and select <strong>Add to Dock</strong>.</p>
                        ) : null}
                        <button onClick={() => setShowPopup(false)}>Close</button>
                    </div>
                </div>
            )}

            {/* ✅ Styles for Popup */}
            <style>{`
                .popup-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 1000;
                }
                .popup {
                    background: white;
                    padding: 20px;
                    border-radius: 10px;
                    text-align: center;
                    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
                }
                .popup h2 {
                    margin: 0 0 10px;
                }
                .popup button {
                    background: #E55426;
                    color: white;
                    border: none;
                    padding: 8px 15px;
                    cursor: pointer;
                    border-radius: 5px;
                    margin-top: 10px;
                }
            `}</style>
        </>
    );
};

export default AddToHomeScreen;
